import { useFormat } from '@ideavivat/vivat-2';

export default {
  types: {
    // _primaryControls: {
    //   width: '3rem',
    //   name: 'เมนู',
    // },
    // _stockWarning: {
    //   width: '1rem',
    //   filter: () => '',
    //   class: {
    //     text: (val: any, row: any) => {
    //       if (row.item.warn_amount > row.item.amount) return 'dot bg-red-500';
    //       return 'dot bg-green-500';
    //     },
    //   },
    // },
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
      class: 'text-center',
    },
    code: {
      name: 'รหัสชิ้นส่วน',
      width: '15rem',
      class: 'mr-3',
      filter: (val: any, row: any) => val || '-',
    },
    item_group_id: {
      name: 'ประเภท',
      width: '8rem',
      // eslint-disable-next-line
      filter: (val: any, row: any) => row.item.item_group?.name ? row.item.item_group.name : '-',
    },
    name: {
      name: 'ชื่อชิ้นส่วน',
      width: '15rem',
      filter: (val: any, row: any) => `${val}`,
    },
    brand: {
      name: 'ยี่ห้อ',
      width: '12rem',
      filter: (val: any, row: any) => val || '-',
    },
    latest_price: {
      name: 'ราคาล่าสุด',
      width: '8rem',
      class: 'text-right',
      // eslint-disable-next-line
      filter: (val: any, row: any) => row.item.poHistory ? row.item.poHistory.latest_price : '-',
    },
    amount: {
      name: 'คงเหลือ',
      width: '5rem',
      class: 'text-right',
    },
    unit: {
      name: 'หน่วย',
      width: '5rem',
    },
  },

  sortable: [
    'name',
    'code',
    'item_group_id',
    'brand',
    'updated_at',
  ],
};
